import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from './constants';

const maintenanceModeConverter = {
  toFirestore(
    settings: MaintenanceMode.Settings,
  ): firebase.firestore.DocumentData {
    return { ...settings };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): MaintenanceMode.Settings {
    const data = snapshot.data(options) as MaintenanceMode.Settings;
    return {
      ...data,
      endsOn: data.endsOn ?? null,
    };
  },
};

// Top-level (not account-scoped) so a single collection can hold both the
// per-customer docs (keyed by accountId) and the 'allCustomers' doc.
const getMaintenanceModesRef = ({
  db,
}: {
  db?: firebase.firestore.Firestore;
} = {}) => {
  return (db ? db : firebase.firestore())
    .collection(STORE_CONSTANTS.MAINTENANCE_MODES_COLLECTION)
    .withConverter(maintenanceModeConverter);
};

export default getMaintenanceModesRef;
